export class ActiveIngredientContentModel {
    public activeIngredientId: number;
    public langId: number;
    public shortDescription: string;
    public description: string;
}